__turbopack_context__.v({
  "item-container": "mochi-refueling-tutorial-carousel-module-scss-module__9soyWq__item-container",
  "item-content": "mochi-refueling-tutorial-carousel-module-scss-module__9soyWq__item-content",
});
